import {
  awaitAnimate,
  Particle,
  ParticleModes,
} from "../../../engine/anims/Particle";
import Colors from "../../Colors";

export const TargetValidParticleBreed = {
  mode: ParticleModes.DRAW_OVER_LAST,
  char: null,
  fg: null,
  bg: Colors.BLUE_1,
  animate: async (particle: Particle<void>) => {
    // eslint-disable-next-line no-constant-condition
    while (true) {
      await awaitAnimate({
        driver: particle.driver,
        from: Colors.BLUE_1,
        to: Colors.BLUE_2,
        duration: 400,
        onUpdate: (latest) => {
          particle.bg = latest;
        },
      });

      await awaitAnimate({
        driver: particle.driver,
        from: Colors.BLUE_2,
        to: Colors.BLUE_1,
        duration: 600,
        onUpdate: (latest) => {
          particle.bg = latest;
        },
      });
    }
  },
};
